import { Locator } from '@/lib/test.locators';

export const topbarLocatorMap = [
  {
    type: 'string',
    element: 'button',
    id: 'topbarProductsPretailoringButtonBackToProducts',
    property: 'pre-tailoring-topbar-button-back-to-products',
  },
  {
    type: 'string',
    element: 'button',
    id: 'topbarProductsPretailoringButtonStep1',
    property: 'pre-tailoring-topbar-button-step-1',
  },
  {
    type: 'string',
    element: 'button',
    id: 'topbarProductsPretailoringButtonStep2',
    property: 'pre-tailoring-topbar-button-step-2',
  },
  {
    type: 'string',
    element: 'button',
    id: 'topbarProductsPretailoringButtonNext',
    property: 'pre-tailoring-topbar-button-next',
  },
  {
    type: 'string',
    element: 'button',
    id: 'topbarProductsPretailoringButtoSaveAsTemplate',
    property: 'pre-tailoring-topbar-button-save-as-template',
  },
  {
    type: 'string',
    element: 'button',
    id: 'topbarProductsTailoringButtonBackToProducts',
    property: 'tailoring-topbar-button-back-to-products',
  },
  {
    type: 'string',
    element: 'button',
    id: 'topbarProductsTailoringButtonStep1',
    property: 'tailoring-topbar-button-step-1',
  },
  {
    type: 'string',
    element: 'button',
    id: 'topbarProductsTailoringButtonStep2',
    property: 'tailoring-topbar-button-step-2',
  },
  {
    type: 'string',
    element: 'button',
    id: 'topbarProductsTailoringButtonExport',
    property: 'tailoring-topbar-button-export',
  },
  {
    type: 'string',
    element: 'button',
    id: 'topbarTemplatesPretailoringButtonBackToProducts',
    property: 'pre-tailoring-template-topbar-button-back-to-templates',
  },
  {
    type: 'string',
    element: 'button',
    id: 'topbarTemplatesPretailoringButtonStep1',
    property: 'pre-tailoring-template-topbar-button-step-1',
  },
  {
    type: 'string',
    element: 'button',
    id: 'topbarTemplatesPretailoringButtonStep2',
    property: 'pre-tailoring-template-topbar-button-step-2',
  },
  {
    type: 'string',
    element: 'button',
    id: 'topbarTemplatesPretailoringButtonNext',
    property: 'pre-tailoring-template-topbar-button-next',
  },
  {
    type: 'string',
    element: 'button',
    id: 'topbarTemplatesTailoringButtonBackToProducts',
    property: 'tailoring-template-topbar-button-back-to-templates',
  },
  {
    type: 'string',
    element: 'button',
    id: 'topbarTemplatesTailoringButtonStep1',
    property: 'tailoring-template-topbar-button-step-1',
  },
  {
    type: 'string',
    element: 'button',
    id: 'topbarTemplatesTailoringButtonStep2',
    property: 'tailoring-template-topbar-button-step-2',
  },
  {
    type: 'string',
    element: 'button',
    id: 'topbarTemplatesTailoringButtonExport',
    property: 'tailoring-template-topbar-button-export',
  },
] as const;

type TopbarLocatorId = Locator<typeof topbarLocatorMap>;

export const topbarLocators: Record<TopbarLocatorId, string> = topbarLocatorMap.reduce(
  (acc, { id, property }) => {
    acc[id] = property;
    return acc;
  },
  {} as Record<TopbarLocatorId, string>,
);
